const initialState = {
  patients: {},
  form: {
    participant_id: null,
    case_id: null,
    case_order: null,
    micro_id: null,
    patient_id: null,
    patient_name: '',
    phase: 0,
    questions: [],
    submit_timestamp: Date.now(),
    currentQuestion: 0,
  },
  surveyHistory: {},
  names: [],
  debug_survey_mode: 3,
  activeCase: null,
};

export function surveyReducer(state = initialState, action) {
  switch (action.type) {
    case "INITIALISE_SURVEY_PATIENT_SUCCEEDED": {
      return {
        ...state,
        patients: {
          [action.payload.patient]: { response_submitted: false },
        },
      };
    }
    case "INITIALISE_SURVEY_PATIENT_WITH_SURVEY_MODES_SUCCEEDED": {
      return {
        ...state,
        patients: {
          [action.payload.patient]: {
            response_submitted: [],
            current_survey_mode: 1,
          },
        },
      };
    }
    case "SELECT_PATIENT_SUCCEEDED": {
      return {
        ...state,
        patients: action.payload.patient,
      };
    }
    case "CHANGE_SURVEY_MODE_SUCCEEDED": {
      return {
        ...state,
        patients: {
          ...state.patients,
          [action.payload.patient]: {
            ...state.patients[action.payload.patient],
            current_survey_mode: action.payload.survey_mode,
            response_submitted: [
              ...state.patients[action.payload.patient].response_submitted,
              action.payload.survey_mode - 1,
            ],
          },
        },
      };
    }
    case "UPDATE_SURVEY_FORM_SUCCEEDED": {
      return {
        ...state,
        form: action.payload.form  // we store a single form in the store
      };
    }

    case "CLEAR_SURVEY_FORM_SUCCEEDED": {
      // reset the form to a fresh blank state
      return {
        ...state,
        form: {
          participant_id: null,
          case_id: null,
          case_order: null,
          micro_id: null,
          patient_id: null,
          patient_name: '',
          phase: 0,
          questions: [],
          submit_timestamp: Date.now(),
          currentQuestion: 0,
        },
      };
    }

    case "STORE_SURVEYED_OBJ_SUCCEEDED": {
      // Directly update or add the new entry using micro_id as the key
      return {
        ...state,
        surveyHistory: {
          ...state.surveyHistory,
          [action.payload.micro_id]: {
            case_id: action.payload.case_id,
            micro_id: action.payload.micro_id,
            patient_mrn: action.payload.patient_mrn,
            name: action.payload.name,
            mode: action.payload.mode,
          },
        },
      };
    }
    case "INIT_PROGRESS_SUCCEEDED": {
      return {
        ...state,
        surveyHistory: action.payload.progress,
      };
    }
    case "STORE_DEBUG_SURVEY_MODE_SUCCEEDED": {
      return {
        ...state,
        debug_survey_mode: action.payload.debug_survey_mode,
      };
    }
    case "RESET": {
      return { ...initialState };
    }
    case "LOGOUT": {
      return { ...initialState };
    }

    case "STORE_ACTIVE_CASE_SUCCEEDED": {
      return {
        ...state,
        activeCase: {
          ...action.payload
        },
      };
    }
    default: {
      return state;
    }
  }
}
